import "./styles.scss";

import moment from "moment";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import Button from "components/Button";

import { passwordAgeLabel, renderIcon } from "./helpers";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "settings-layout-password-mobile";

const PasswordMobile = ({ header, content, onClick }) => {
  const { t, i18n } = useTranslation();

  const daysSinceChange = content?.last_password_changed
    ? moment().diff(moment(content.last_password_changed), "days")
    : null;

  const isSuccess = daysSinceChange !== null ? daysSinceChange < 90 : false;

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--success`]: isSuccess,
      })}
    >
      {header?.title && (
        <div className={`${mainClass}__header`}>
          <p>{header.title}</p>
          {header?.action?.label && (
            <button type="button" onClick={header.action?.onClick}>
              {header.action.label}
              <i>
                <ArrowIcon />
              </i>
            </button>
          )}
        </div>
      )}
      <div className={`${mainClass}__content`}>
        <div className={`${mainClass}__content-icon`}>
          {renderIcon(isSuccess ? "success" : "default")}
        </div>
        <div className={`${mainClass}__content-last`}>
          <p>
            {t(
              isSuccess
                ? "Your panel password was changed less than"
                : "Your panel password has been changed",
            )}
          </p>
          <p>{passwordAgeLabel(daysSinceChange, i18n?.language)}</p>
        </div>
        <p className={`${mainClass}__content-advice`}>
          {isSuccess ? t("Everything is fine.") : content?.advice}
        </p>
      </div>
      {typeof onClick === "function" && (
        <div className={`${mainClass}__cta`}>
          <Button onClick={onClick}>Zmień hasło</Button>
        </div>
      )}
    </div>
  );
};

export default PasswordMobile;
